export default __webpack_public_path__ + "static/Eliot-9490b3051c408b1dc82ab388824aa8881837c2bbc03d50c118635f3dfa496313.svg";